import {
  Container,
  Stack,
  styled,
  Box,
  Button,
  useTheme,
  List,
  ListItem,
  ListItemButton,
  IconButton,
  Drawer,
  Typography,
  ListItemText,
} from "@mui/material";
import logoFull from "../assets/images/logo.svg";
import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { RiMenu3Line } from "react-icons/ri";
import { HashLink as Link } from "react-router-hash-link";
import LoginDialog from "./dialogs/LoginDialog";
import CreateAccountDialog from "./dialogs/CreateAccountDialog";
import { ReactComponent as SettingsIcon } from "../assets/icons/settings_icons.svg";
import userIcon from "../assets/icons/userImage_icon.svg";
import SettingsDialog from "./dialogs/SettingsDialog";
import SubscriptionDialog from "./dialogs/SubscriptionDialog";
import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import { doGetUser } from "../reducers/user/user.service";
import axios from "axios";
import React from "react";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";

const Image = styled("img")``;

const headerList = [
  ["Home", "/"],
  [<Link to="/#whychooseus">Why Choose us</Link>, ""],
  ["Faqs", "/faqs"],
];

const DrawerList = ({
  theme,
  handleOpenLogin,
  setOpenDrawer,
  setDisplayAsLogin,
}) => {
  return (
    <Box
      sx={{
        width: 200,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        position: "relative",
        backgroundColor: theme.palette.secondary.main,
        zIndex: 1,
      }}
      role="presentation"
    >
      <List>
        {headerList.map((item, index) => (
          <ListItem key={index} disablePadding>
            <ListItemButton
              onClick={() => setOpenDrawer(false)}
              smooth
              to={item[1]}
            >
              <ListItemText primary={item[0]} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Box
        display={{ xs: "block", sm: "none" }}
        px={"16px"}
        mt={"auto"}
        mb={"20px"}
      >
        <Button
          variant="outlined"
          onClick={() => {
            setOpenDrawer(false);
            setDisplayAsLogin(true);
            handleOpenLogin();
          }}
          sx={{
            color: "primary.main",
            width: "100%",
            mb: "10px",
            pb: "2px !important",
            height: "40px",
          }}
        >
          Login
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            setOpenDrawer(false);
            setDisplayAsLogin(false);
            handleOpenLogin();
          }}
          sx={{
            boxShadow: "none !important",
            border: "none !important",
            width: "100%",
            height: "40px",
            pb: "2px !important",
          }}
        >
          Sign up
        </Button>
      </Box>
    </Box>
  );
};

const LoginDrawerList = ({
  theme,
  handleOpenSubscription,
  handleOpenSettings,
}) => {
  return (
    <Box
      sx={{
        width: 200,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        position: "relative",
        backgroundColor: "secondary.main",
        zIndex: 1,
      }}
      role="presentation"
    >
      <List>
        <ListItem disablePadding>
          <ListItemButton onClick={() => handleOpenSubscription()} smooth>
            <ListItemText primary={"Subscribe"} />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton onClick={() => handleOpenSettings()} smooth>
            <ListItemText primary={"Settings"} />
          </ListItemButton>
        </ListItem>
      </List>
    </Box>
  );
};

const LoginHeader = () => {
  const [openDrawer, setOpenDrawer] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Handle Create account dialog
  const [openCreateAccount, setOpenCreateAccount] = useState(false);
  const handleCloseCreateAccount = () => setOpenCreateAccount(false);
  const handleOpenCreateAccount = () => setOpenCreateAccount(true);

  // Handle settings dialog
  const [openSettings, setOpenSettings] = useState(false);
  const handleOpenSettings = () => setOpenSettings(true);
  const handleCloseSettings = () => setOpenSettings(false);

  // Handle subscription dialog
  const [openSubscription, setOpenSubscription] = useState(false);
  const handleOpenSubscription = () => setOpenSubscription(true);
  const handleCloseSubscription = () => setOpenSubscription(false);

  const fullName = useSelector((state) => state.user.fullName);
  const firstTime = useSelector((state) => state.user.firstTime);
  const y = useSelector((state) => state.auth.accessToken);
  useEffect(() => {
    if (y && !axios.defaults.headers.common["Authorization"]) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${y}`;
    }
    const fetchUser = async () => await dispatch(doGetUser());
    fetchUser();
  }, [y, dispatch]);

  useEffect(() => {
    if (firstTime) {
      handleOpenCreateAccount();
    }
  }, [firstTime]);

  return (
    <header style={{ backdropFilter: "blur(25px)" }}>
      <Container maxWidth={"xl"} disableGutters>
        <Stack
          direction={"row"}
          sx={{
            alignItems: "center",
            justifyContent: "space-between",
            px: { lg: "100px", sm: "34px", xs: "24px" },
            pt: "15px",
            pb: "10px",
            borderBottom: "1px solid #FFFFFF1F",
            zIndex: 1000,
          }}
        >
          <Box>
            <Button onClick={() => navigate("/")}>
              <Image
                src={logoFull}
                alt="logo"
                sx={{
                  width: { sm: "100px", xs: "80px" },
                }}
              />
            </Button>{" "}
          </Box>

          <Box
            sx={{
              display: { sm: "flex", xs: "none" },
              gap: "16px",
              alignItems: "center",
            }}
          >
            <Box
              onClick={() => handleOpenSubscription()}
              sx={{ width: 50, height: 50 }}
            >
              <DotLottieReact
                src={require("../assets/icons/subscription.lottie")}
                loop
                autoplay
              />
            </Box>

            <IconButton onClick={() => handleOpenSettings()} sx={{ p: 0 }}>
              <SettingsIcon />
            </IconButton>
            <Box
              onClick={() => handleOpenSettings()}
              sx={{
                display: "flex",
                p: "8px 10px",
                backgroundColor: "#FFFFFF33",
                borderRadius: "50px",
                gap: "6px",
                color: "white",
                cursor: "pointer",
              }}
            >
              <Image src={userIcon} />
              <Typography
                sx={{
                  fontFamily: "secondaryFontFamily",
                  fontWeight: 500,
                  fontSize: "16px",
                }}
              >
                {fullName}
              </Typography>
            </Box>
          </Box>

          <IconButton
            sx={{ p: 0, display: { xs: "block", sm: "none" } }}
            onClick={() => setOpenDrawer(true)}
          >
            <RiMenu3Line color="white" />
          </IconButton>

          <Drawer
            anchor="right"
            open={openDrawer}
            onClose={() => setOpenDrawer(false)}
          >
            <LoginDrawerList
              handleOpenSettings={handleOpenSettings}
              handleOpenSubscription={handleOpenSubscription}
            />
          </Drawer>
        </Stack>
        <SettingsDialog
          open={openSettings}
          handleDialogClose={handleCloseSettings}
        />
        <CreateAccountDialog
          open={openCreateAccount}
          handleDialogClose={handleCloseCreateAccount}
        />
        <SubscriptionDialog
          open={openSubscription}
          handleDialogClose={handleCloseSubscription}
        />
      </Container>
    </header>
  );
};

const NormalHeader = () => {
  const navigate = useNavigate();

  // Handle side drawer
  const [openDrawer, setOpenDrawer] = useState(false);

  // Handle login dialog
  const [openLogin, setOpenLogin] = useState(false);
  const [showTelegramJoin, setShowTelegramJoin] = useState(true);
  const [displayAsLogin, setDisplayAsLogin] = useState(false);
  const handleOpenLogin = () => setOpenLogin(true);
  const handleCloseLogin = () => setOpenLogin(false);

  const { pathname } = useLocation();
  const theme = useTheme();

  return (
    <header>
      <Container maxWidth={"xl"} disableGutters>
        <Stack
          direction={"row"}
          sx={{
            alignItems: "center",
            justifyContent: "space-between",
            px: { lg: "100px", sm: "34px", xs: "24px" },
            pb: "10px",
            pt: "15px",
            zIndex: 1000,
          }}
        >
          <Box>
            <Button onClick={() => navigate("/")}>
              <Image
                src={logoFull}
                alt="logo"
                sx={{
                  width: { sm: "100px", xs: "80px" },
                }}
              />
            </Button>{" "}
          </Box>
          <Box
            sx={{
              display: "flex",
              gap: { md: 1, xs: 4 },
              alignItems: "center",
            }}
          >
            {headerList.map((item, _) => (
              <Button
                sx={{
                  color: pathname === item[1] ? "primary.main" : "white",
                  display: { md: "flex", xs: "none" },
                }}
                key={item[0]}
                onClick={() => navigate(`${item[1]}`)}
              >
                {item[0]}
              </Button>
            ))}
            <Button
              onClick={() => {
                setDisplayAsLogin(true);
                setOpenLogin(true);
              }}
              sx={{ display: { sm: "flex", xs: "none" } }}
            >
              Login
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                setShowTelegramJoin(true);
                setDisplayAsLogin(false);
                handleOpenLogin();
              }}
              sx={{
                boxShadow: "none !important",
                border: "none !important",
                px: "20px",
                display: { sm: "flex", xs: "none" },
              }}
            >
              Sign Up
            </Button>
            <IconButton
              sx={{ p: 0, display: { md: "none" } }}
              onClick={() => setOpenDrawer(!openDrawer)}
            >
              <RiMenu3Line color="white" />
            </IconButton>
          </Box>

          <Drawer
            anchor="right"
            open={openDrawer}
            onClose={() => setOpenDrawer(false)}
          >
            <DrawerList
              theme={theme}
              handleOpenLogin={handleOpenLogin}
              setOpenDrawer={setOpenDrawer}
              setDisplayAsLogin={setDisplayAsLogin}
            />
          </Drawer>
        </Stack>

        <LoginDialog
          open={openLogin}
          handleDialogClose={handleCloseLogin}
          handleOpenLogin={handleOpenLogin}
          displayAsLogin={displayAsLogin}
          showTelegramJoin={showTelegramJoin}
        />
      </Container>
    </header>
  );
};

const Header = () => {
  const { pathname } = useLocation();
  const loggedIn =
    useSelector((state) => state.auth.accessToken) ||
    localStorage.getItem("accessToken");
  useEffect(() => {}, [loggedIn]);
  if (
    pathname.includes("terms-and-conditions") ||
    pathname.includes("privacy-policy") ||
    pathname.includes("404")
  )
    return null;
  return loggedIn ? <LoginHeader /> : <NormalHeader />;
};

export default Header;
